export default (theme) => ({
  root: {
    padding: theme.spacing(3),
  },
  wrapper: {
    // maxWidth: 600,
  },
  header: {
    marginBottom: theme.spacing(3),
  },
  filterIcon: {
    marginRight: theme.spacing(1),
  },
  filterWropper: {
    display: 'flex',
  },
})
